module.exports = __webpack_public_path__ + "img/T953.288eb64e.jpg";